import { useInfiniteQuery } from "@tanstack/react-query";

import apiService from "../services/api";

import type { IAward, ILastKey } from "@/interfaces/IAward";

interface ApiResponse {
  awards: IAward[];
  last_key: ILastKey | null;
}

const fetchAwards = async ({ pageParam }: { pageParam: any }) => {
  const response = await apiService.fetchAwards(3, pageParam);
  return response.data;
};

const useAwards = () =>
  useInfiniteQuery<ApiResponse>({
    queryKey: ["awards"],
    queryFn: fetchAwards,
    initialPageParam: null,
    getNextPageParam: (resp) => resp.last_key,
    staleTime: 1000 * 60 * 60 * 24,
  });

export default useAwards;
